import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Role } from '@models';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private http = inject(HttpClient);

  create(name: string, endpoints: string[]) {
    return this.http.post<Role>(
      `${environment.komainuHost}/role/`,
      {
        name: name,
        endpoints: endpoints,
      } as Role,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  read(id: string) {
    return this.http.get<Role>(
      `${environment.komainuHost}/role/${id}`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  update(
    id: string,
    name: string,
    endpoints: string[],
  ) {
    return this.http.put<Role>(
      `${environment.komainuHost}/role/${id}`,
      {
        name: name,
        endpoints: endpoints,
      } as Role,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  delete(id: string) {
    return this.http.delete<void>(
      `${environment.komainuHost}/role/${id}`,
    );
  }

  addUser(id: string, userId: string) {
    return this.http.post<void>(
      `${environment.komainuHost}/role/${id}/user/${userId}`,
      null,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      },
    );
  }

  removeUser(id: string, userId: string) {
    return this.http.delete<void>(
      `${environment.komainuHost}/role/${id}/user/${userId}`,
    );
  }
}
